import PropTypes from 'prop-types';
import { Box, Modal, Typography, Stack, IconButton, Button, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// ------------------------------------------------------------------------------------------------

ConfirmationPopup.propTypes = {
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
    children: PropTypes.node,
};

// ------------------------------------------------------------------------------------------------

export default function ConfirmationPopup({ title, msg, onConfirm, onDismiss, children }) {

    const handleYes = async () => {
        try {
            await onConfirm();
        } finally {
            onDismiss('close');
        }
    };

    const buttonStyle = {
        alignItems: 'center',
        borderRadius: "10px",
        height: '2em',
        padding: '0.3em',
        color: 'white'
    };

    return (
        <Modal
            open
            BackdropProps={{
                style: { backgroundColor: 'transparent' }
            }}
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 'inset 0 0 0 #b3b3b3, 0 1px 0 0 #b3b3b3, 0 1.5px 1px #999999 !important',
                borderRadius: 1.5,
                width: 300,
            }}>
                <Stack
                    direction='row'
                    alignItems="center"
                    justifyContent='space-between'
                    sx={{
                        bgcolor: '#f27c88',
                        height: 42,
                        width: '100%',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                    }}
                >
                    <Typography variant='subtitle1' sx={{ color: '#fff', p: 2 }}>
                        {title}
                    </Typography>
                    <IconButton onClick={onDismiss} sx={{ p: 0, color: '#fff' }}>
                        <CloseIcon sx={{ width: '20px', height: '20px' }} />
                    </IconButton>
                </Stack>

                <Stack direction='row' alignItems="center" justifyContent='space-between' sx={{ p: 1 }}>
                    <Typography variant='body2'>
                        {msg}
                    </Typography>
                </Stack>

                <Divider sx={{ mt: 2 }} />

                <Box sx={{ m: 1.7, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        variant='contained'
                        sx={{
                            marginRight: 1, bgcolor: '#43b5a2', minWidth: '2.4em',
                            minHeight: '1.5em', color: '#fff', '&:hover': {
                                bgcolor: '#43b5a2',
                            },
                        }}
                        onClick={onDismiss}
                        style={buttonStyle}
                    >
                        No
                    </Button>

                    <Button
                        variant='contained'
                        sx={{
                            bgcolor: '#ED5565', color: '#fff', minWidth: '1.5em',
                            minHeight: '1.5em', '&:hover': {
                                bgcolor: '#ED5565',
                            },
                        }}
                        onClick={handleYes}
                        style={buttonStyle}
                    >
                        Yes
                    </Button>
                </Box>

                <Box>{children}</Box>

                
            </Box>
        </Modal>
    );
}
